<template>
<div class="container mb-4">
  <div class="wrapper">
    <DataTable :value="ARCHIVED_INVOICES" :selection.sync="selectedOrder" @row-select="invoiceDetails(selectedOrder)" selectionMode="single">
      <Column field="id" header="Id" />
      <Column field="type" header="Fakturatyp" />
      <Column field="name" header="Namn" />
    </DataTable>
  </div>
</div>
</template>

<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'

import { mapGetters } from 'vuex'

export default {
  components: {
    DataTable,
    Column
  },
  data () {
    return {
      selectedOrder: null
    }
  },
  async mounted () {
    await this.$store.dispatch('GET_ARCHIVED_INVOICES')
  },
  computed: {
    ...mapGetters(['ARCHIVED_INVOICES'])
  },
  methods: {
    invoiceDetails (invoice) {
      switch (invoice.type) {
        case 'feralco':
          this.$router.push({ name: 'InvoiceFeralcoCreate', params: { id: invoice.id, archive: true } })
          break
        case 'feralcoIntern':
          this.$router.push({ name: 'InvoiceFeralcoInternCreate', params: { id: invoice.id, archive: true } })
          break
        case 'hydro':
          this.$router.push({ name: 'InvoiceHydroCreate', params: { id: invoice.id, archive: true } })
          break
        default:
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Invoices/InvoiceArchive.vue